module.exports = __webpack_public_path__ + "img/denmark-liver-cancer-male.4a7ca7aa.png";